export class Selfie {
	public Image: string;
	public Latitude: number;
	public Longitude: number;
	public BrowserName : string;
	public BrowserVersion:string
}
